import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'properties';

export function useGetAllProperties(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetProperty(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateProperty() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateProperty({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteProperty({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
